import React from "react";
import { getConfiguration } from '../../utils/configuration';
import { getCurrencySymbol } from '../../utils/getCurrencySymbol';
import { getPrintableAmount } from '../../utils/getPrintableAmount';

export default function MstbetHorseTicketSelections(props) {
    const conf =getConfiguration();
    const ticketData = props.ticketData;
	const clearBoth = {clear: "both"};
	const currency = getCurrencySymbol(props.conf.cs.ct);
    let typeGame = ticketData?.type_game;
    const isFixedOddType = typeGame == 'FIXEDODD';
    const isTotPsrType =  (typeGame == 'TOT' ||  typeGame == 'PSR');
    const ticket = ticketData?.ticket?.[0];

    return (
        <>
        {isFixedOddType &&
            <>
            {"0" == ticketData?.ticket_type?
                <>
                {ticket?.bets?.map((bet) => {
                    return (
                        <>
                            <div className="event_row">	
                                <div className="td-100 bold left">{bet.meeting + " " + bet.race_type + " " + bet.race  + "° CORSA"} </div>
                                <div style={clearBoth}></div>
                                {bet.event_desc &&
                                    <>
                                        <div className="td-100 bold left">{bet.event_desc} </div>
                                        <div style={clearBoth}></div>
                                    </>
                                }
                            </div>
                            <div className="event_row">	
                                <div className="td-20 left">{bet.bet_desc} </div>
                                <div className="td-70 left bold">{bet.horse_cod} - {bet.horse_desc}</div>		
                                <div className="td-10 left odd textright bold">{getPrintableAmount(bet.odd, conf.cs.m, conf.cs.nd) }</div>
                                <div style={clearBoth}></div>
                            </div>
                        </>
                    )
                })
                }
                </>
            :
            "2" == ticketData?.ticket_type?
                <>
                <div style={{ marginTop : "5px", fontSize: "1px"}}>.</div>
                {ticket?.races?.map((race) => {
                    return (
                        <>
                           <div className="event_row">	
                                <div className="td-100 bold left">{race.meeting + " " + race.race_type + " " + race.race  + "° CORSA"} </div>
                                <div style={clearBoth}></div>
                            </div>
                            {race?.bets?.map((bet) => {
                                return bet?.horses?.map((horse) => {
                                    return (
                                        <>
                                            <div className="event_row">	
                                                <div className="td-20 left">{bet.bet_desc} </div>
                                                <div className="td-70 left bold">{horse.horse_cod} - {horse.horse_desc}</div>		
                                                <div className="td-10 left odd textright bold">{getPrintableAmount(horse.odd, conf.cs.m, conf.cs.nd) }</div>
                                                <div style={clearBoth}></div>
                                            </div>
                                        </>
                                    )
                                })
                            })
                            }
                        </>
                    )
                })
                }
                </>
            :
                <>
                {ticket?.bets?.map((bet) => {
                    let outcomes = '';

                    bet?.column?.map((column,index) => {
                        outcomes+=column.sel;
                        if(index < bet.column.length-1) {
                            outcomes+=' / ';
                        }
                    })

                    return (
                        <>
                            <div className="event_row">
                                <div className="td-10 left">{bet.multiplier} </div>
                                <div className="td-20 left">{bet.bet_desc} </div>
                                <div className="td-40 left textNewLine">{outcomes} </div>
                                <div className="td-30 left odd textright bold">{currency + ' ' + getPrintableAmount(bet.stake, conf.cs.m, conf.cs.nd) }</div>
                                <div style={clearBoth}></div>
                            </div>
                        </>
                    )
                })
                }
                </>
            }
            
            </>
        }

        {isTotPsrType &&
            <>{ticket?.scommesse?.map((bet) => {
                let outcomes = '';
                
                bet?.colonna?.map((column,index) => {
                    outcomes+=column.esiti;
                    if(index < bet.colonna.length-1) {
                        outcomes+=' / ';
                    }
                })

                return (
                    <>
                        <div className="event_row">
                            <div className="td-10 left">{bet.moltiplicatore} </div>
                            <div className="td-20 left">{bet.scommessa_desc+' '+bet.sistema_desc} </div>
                            <div className="td-40 left textNewLine">{outcomes} </div>
                            <div className="td-30 left odd textright bold">{currency + ' ' + bet.prezzo }</div>
                            <div style={clearBoth}></div>
                        </div>
                    </>
                )
            })
            }
            </>
        }
        
        </>
    )
}